module.exports = __webpack_public_path__ + "static/media/project-restaurant.a7a53b52.jpg";